export const NewsCatcherLogo = ({ height = 24 }: { height?: number }) => {
  return (
    <svg
      height={height}
      viewBox="0 0 32 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.2635 1.16382C10.8071 3.53923 5.58391 6.39145 0.429864 9.35585L0 9.60397V10.098C0 12.9805 0.036722 16.1261 0.157689 18.9956C0.289456 21.9686 0.457945 24.9352 0.810045 27.8953C1.43432 22.741 1.62441 17.5177 1.71081 12.3289L1.72377 10.5964C6.70717 7.66869 11.6258 4.62229 16.2635 1.16382Z"
        fill="currentColor"
      />
      <path
        d="M24.0119 5.63199C18.5554 8.00955 13.3301 10.8639 8.17821 13.8305L7.74834 14.0786V14.5727C7.74834 17.4529 7.78723 20.5986 7.90819 23.4681C8.03996 26.4389 8.20845 29.4055 8.56271 32.3634C9.18699 27.2113 9.37492 21.988 9.46132 16.8014L9.47428 15.0689C14.4577 12.139 19.3784 9.09262 24.014 5.62983L24.0119 5.63199Z"
        fill="currentColor"
      />
      <path
        d="M31.933 22.7863L16.8748 30.5382C16.9245 29.755 16.9677 28.9697 17.0045 28.1844L32 18.5533L17.0844 26.2297C17.1125 25.4336 17.1341 24.6396 17.1557 23.8456L31.933 14.3483L17.1967 21.9233C17.201 21.7076 17.2053 21.4896 17.2097 21.2739L17.2226 19.5436C22.206 16.6158 27.1268 13.5651 31.7624 10.1045C26.3059 12.4821 21.0806 15.3364 15.9287 18.303L15.4989 18.5511V19.0452C15.4967 21.9276 15.5356 25.0711 15.6587 27.9406C15.7624 30.3117 15.892 32.6806 16.121 35.0431C16.1685 35.5717 16.2247 36.0981 16.2873 36.6267C16.2938 36.6957 16.3024 36.7669 16.3111 36.836L31.717 27.0107L16.5314 34.8316C16.607 34.0722 16.6718 33.3084 16.7323 32.5468L31.933 22.7885V22.7863Z"
        fill="currentColor"
      />
      <path
        d="M20.1366 3.39684C14.6802 5.77441 9.45484 8.62878 4.30296 11.5953L3.87309 11.8435V12.3375C3.87309 15.2178 3.91198 18.3634 4.03294 21.2329C4.16471 24.2038 4.3332 27.1704 4.68746 30.1283C5.31173 24.9762 5.49966 19.7529 5.58607 14.5662L5.59903 12.8338C10.5824 9.90386 15.5032 6.85747 20.1388 3.39468L20.1366 3.39684Z"
        fill="currentColor"
      />
      <path
        d="M27.8871 7.86719C22.4307 10.2448 17.2053 13.0991 12.0535 16.0657L11.6236 16.3138V16.8079C11.6236 19.6882 11.6625 22.8338 11.7834 25.7033C11.9152 28.6741 12.0837 31.6407 12.438 34.5986C13.0622 29.4465 13.2502 24.2232 13.3366 19.0366L13.3495 17.3041C18.3329 14.3742 23.2537 11.3278 27.8893 7.86504L27.8871 7.86719Z"
        fill="currentColor"
      />
    </svg>
  );
};
